(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  const root = document.documentElement;
  root.classList.add('midnight-motion-ready');

  const reveal = () => {
    const sections = document.querySelectorAll('.shopify-section:not(.midnight-reveal)');
    sections.forEach((section, index) => {
      section.classList.add('midnight-reveal');
      if (index < 2 || section.getBoundingClientRect().top < window.innerHeight * .92) {
        section.classList.add('midnight-visible');
      } else {
        observer.observe(section);
      }
    });
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('midnight-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });

  const addRipple = (event) => {
    const target = event.target instanceof Element
      ? event.target.closest('button, .button, [role="button"], summary')
      : null;
    if (!target || target.matches(':disabled')) return;

    const ripple = document.createElement('span');
    ripple.className = 'midnight-ripple';
    ripple.style.left = event.clientX + 'px';
    ripple.style.top = event.clientY + 'px';
    ripple.style.color = getComputedStyle(target).color;
    document.body.appendChild(ripple);
    ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
  };

  document.addEventListener('pointerdown', addRipple, { passive: true });
  document.addEventListener('shopify:section:load', reveal);
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
  window.addEventListener('pageshow', reveal);

  if (document.readyState !== 'loading') reveal();

  const mutationObserver = new MutationObserver(reveal);
  mutationObserver.observe(document.body, { childList: true, subtree: true });
})();